import { Grid, Typography } from '@mui/material'
import LatestVideos from '../components/LatestVideos/LatestVideos'
import MainFeaturedPost from '../components/MainFeaturedPost/MainFeaturedPost'
import SkillSetList from '../organisms/SkillSetList'
import featuredPost from '../data/featuredPost.json'
import { config } from '../config/config'

function Home() {
    return (
        <Grid container>
            <Grid item lg={12}>
                <MainFeaturedPost post={featuredPost} />
            </Grid>
            <Grid item>
                <Grid container spacing={2} pl={2}>
                    <Grid item>
                        <Typography variant="h5">{config.HOME_PAGE.SKILLSET_TITLE} <hr /></Typography>
                        <SkillSetList />
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant="h5">{config.HOME_PAGE.LATEST_VIDEOS_TITLE} <hr /></Typography>
                        <LatestVideos />
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    )
}

export default Home